import { ArrayOps, StringOps } from '../lift';
/**
 * Joins the items into a string, using a separator.
 */
export function join(separator) {
    if (separator === void 0) { separator = ','; }
    return new StringOps(this.value().join(separator));
}
ArrayOps.prototype.join = join;
